// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2Fqim","paymentContainer":"PaymentPage_paymentContainer__2yhW5"};